/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PhysicianScheduleViewerAliases {
  AUTOCOMPLETE_APPOINTMENTS_ESTABILISHMENT = 'autocomplete-appointments-estabilishment',
  AUTOCOMPLETE_APPOINTMENTS_TYPE = 'autocomplete-appointments-type',
  DATE_PICKER_START_DATE = 'date-picker-start-date',
  FETCH_APPOINTMENTS_ESTABILISHMENT = 'fetch-appointments-estabilishment',
  FETCH_APPOINTMENTS_TYPE = 'fetch-appointments-type',
  FILTER_FIELD_APPOINTMENTS_ESTABILISHMENT = 'filter-field-appointments-estabilishment',
  FILTER_FIELD_APPOINTMENTS_TYPE = 'filter-field-appointments-type',
  FILTER_FIELD_DATE_START = 'filter-field-date-start',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  MAPPER_APPOINTMENTS_ESTABILISHMENT = 'mapper-appointments-estabilishment',
  MAPPER_APPOINTMENTS_TYPE = 'mapper-appointments-type',
  PHYSICIAN_SCHEDULE_APPOINTMENTS_CARD = 'physician-schedule-appointments-card',
  PHYSICIAN_SCHEDULE_CALENDAR_CONTEXTUAL_BAR = 'physician-schedule-calendar-contextual-bar',
  PHYSICIAN_SCHEDULE_CALENDAR_PANEL = 'physician-schedule-calendar-panel',
  PHYSICIAN_SCHEDULE_CARD = 'physician-schedule-card',
  PHYSICIAN_SCHEDULE_CARD_LIST_DECK = 'physician-schedule-card-list-deck',
  PHYSICIAN_SCHEDULE_CARD_LIST_PANEL = 'physician-schedule-card-list-panel',
  PHYSICIAN_SCHEDULE_CARD_LIST_PANEL_DECK = 'physician-schedule-card-list-panel-deck',
  PHYSICIAN_SCHEDULE_CARD_LIST_PANEL_TEXT = 'physician-schedule-card-list-panel-text',
  PHYSICIAN_SCHEDULE_CARD_LIST_TITLE = 'physician-schedule-card-list-title',
  PHYSICIAN_SCHEDULE_CARROSEL_SEGMENTED_CONTROL = 'physician-schedule-carrosel-segmented-control',
  PHYSICIAN_SCHEDULE_DATE_PICKER = 'physician-schedule-date-picker',
  PHYSICIAN_SCHEDULE_FILTERED_LIST = 'physician-schedule-filtered-list',
  PHYSICIAN_SCHEDULE_LAYOUT = 'physician-schedule-layout',
  PHYSICIAN_SCHEDULE_LEGENDS = 'physician-schedule-legends',
  PHYSICIAN_SCHEDULE_SEGMENTED_FIELD = 'physician-schedule-segmented-field',
  PHYSICIAN_SCHEDULE_SEGMENTED_FORM = 'physician-schedule-segmented-form',
  PHYSISCIAN_SCHEDULE_FILTER = 'physiscian-schedule-filter',
  SUPPRESS_HEADING_MARGIN = 'suppress-heading-margin',
  TEXT_APPOINTMENTS_ESTABILISHMENT = 'text-appointments-estabilishment',
  TEXT_APPOINTMENTS_TYPE = 'text-appointments-type',
}
export { PhysicianScheduleViewerAliases };
